import { motion } from "framer-motion";
import { formatCurrency } from "../../../data/mock/dashboardData";

export default function TopPortfoliosChart({ items: itemsProp } = {}) {
  if (!Array.isArray(itemsProp) || itemsProp.length === 0) {
    return (
      <p className="flex min-h-[160px] items-center justify-center text-sm text-primary/40">
        No portfolio data yet.
      </p>
    );
  }

  const max = Math.max(
    1,
    ...itemsProp.map((p) => Number(p.collected ?? p.outstanding ?? p.total) || 0)
  );
  const items = itemsProp.slice(0, 8).map((p) => {
    const value = Number(p.collected ?? p.outstanding ?? p.total) || 0;
    return {
      name: p.name || p.label || "Unknown",
      collected: value,
      rate: p.rate != null ? Number(p.rate) : Math.round((value / max) * 100),
    };
  });

  return (
    <ol className="space-y-3">
      {items.map((p, i) => (
        <li key={`${p.name}-${i}`}>
          <div className="mb-1 flex items-baseline justify-between gap-2">
            <span className="flex items-center gap-2 text-xs font-semibold text-primary">
              <span className="flex h-5 w-5 items-center justify-center rounded-md bg-primary/[0.08] text-[10px] font-bold text-primary/50">
                {i + 1}
              </span>
              {p.name}
            </span>
            <span className="text-[11px] font-bold text-primary">{formatCurrency(p.collected)}</span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-primary/[0.06]">
            <motion.div
              className="h-full rounded-full bg-gradient-to-r from-accent to-accent-dark"
              initial={{ width: 0 }}
              animate={{ width: `${Math.min(100, p.rate)}%` }}
              transition={{ duration: 0.65, delay: 0.12 + i * 0.1, ease: "easeOut" }}
            />
          </div>
          <p className="mt-0.5 text-[10px] text-primary/35">{p.rate}% of top book</p>
        </li>
      ))}
    </ol>
  );
}
